import React, { Fragment } from 'react';
import { Row, Col,Table, Badge } from 'reactstrap';


const Assistance = ({ data }) => {
    // console.log(data,'data product info')
    const Assistance = data?.types;

        return (
        <Fragment>
            <Row className='mt-4'>
                <Col sm="12" >
                    <Table>
                        {/* <tbody> */}
                            {/* <tr>
                                <th>Pre</th>
                                <td className="text-right pr-5">{data.Company?.client_company_name || '-'}</td>
                            </tr>
                            <tr>
                                <th>During</th>
                                <td className="text-right pr-5">{data.title || '-'}</td>
                            </tr>
                            <tr>
                                <th>post</th>
                                <td className="text-right pr-5">{data.sales_category?.name || '-'}</td>
                            </tr> */}

                            <thead>
                            <tr>
                                <th>Pre</th>
                                <th>During</th>
                                <th>Post</th>
                            </tr>
                        </thead>
                        <tbody className="mtd-bg">
                            {Assistance?.length > 0 ? (
                                Assistance?.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item?.pre_inclusion || '-'}</td>
                                        <td>{item?.during_inclusion || '-'}</td>
                                        <td>{item?.post_inclusion || '-'}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="3" className="text-center">No records found.</td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </Col>
            </Row>
        </Fragment>
    );
};

export default Assistance;